export default "__VITE_ASSET__Hi9QiO0z__"